export const PAYMENT_TYPE_OPTIONS = [
  { label: "Cash", value: "Cash" },
  { label: "Credit Card", value: "Credit Card" },
  { label: "QRIS", value: "QRIS" },
];

export const ORDER_TYPE_OPTIONS = [
  { label: "Dine In", value: "Dine In" },
  { label: "Take Away", value: "Take Away" },
  { label: "Delivery", value: "Delivery" },
];

export const CSV_ACCEPTED_TYPES = ".csv";
export const CSV_MAX_SIZE = 100 * 1024 * 1024; // 100MB
export const CSV_COLUMN_MAPPING = [
  "Invoice No.",
  "Creation Date",
  "Invoice Discount",
  "Description",
  "Item",
  "Product Code",
  "Category",
  "Amount",
  "Amount (Excl Tax)",
  "Tax",
  "Discount",
  "Quantity",
  "Unit Price",
  "Variant",
  "Variant Code",
  "Variant Amount",
  "Variant Amount (Excl Tax)",
  "Variant Tax",
  "Variant Quantity",
  "Variant Unit Price",
  "Payment Type",
  "Tax Group",
  "Order Type",
  "Category Group",
];
